import { render, staticRenderFns } from "./DeliveryCampaignImportDeliveriesConfigurationPage.vue?vue&type=template&id=07317a14&scoped=true"
import script from "./DeliveryCampaignImportDeliveriesConfigurationPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignImportDeliveriesConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCampaignImportDeliveriesConfigurationPage.vue?vue&type=style&index=0&id=07317a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07317a14",
  null
  
)

export default component.exports